export const enum FEEDBACK {
    NONE = 'NONE',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
}
